import Component from "./stat-card.umd.min";
import "./stat-card.css";

Component.install = function (Vue) {
  Vue.component(Component.name, Component);
};

export default Component;
